import { useQuery } from "@tanstack/react-query";
import { StatusConfig } from "@shared/schema";

export function useStatusConfigs(category?: string) {
  const queryKey = category 
    ? [`/api/status-configs/${category}`] 
    : ['/api/status-configs'];
    
  const { data: statusConfigs = [], isLoading, isError } = useQuery<StatusConfig[]>({
    queryKey,
  });

  // Group by category if fetching all
  const groupedConfigs = category ? { [category]: statusConfigs } : statusConfigs.reduce((acc, config) => {
    if (!acc[config.category]) {
      acc[config.category] = [];
    }
    acc[config.category].push(config);
    return acc;
  }, {} as Record<string, StatusConfig[]>);

  // Get default status for a category
  const getDefaultStatus = (cat: string = category || 'pulse') => {
    const configs = category ? statusConfigs : groupedConfigs[cat] || [];
    return configs.find(s => s.isDefault)?.statusKey || configs[0]?.statusKey || 'empty';
  };

  // Get status by key
  const getStatusByKey = (statusKey: string, cat?: string) => {
    const configs = category ? statusConfigs : (cat ? groupedConfigs[cat] : Object.values(groupedConfigs).flat());
    return Array.isArray(configs) ? configs.find(s => s.statusKey === statusKey) : undefined;
  };

  // Get status by display name
  const getStatusByDisplayName = (displayName: string, cat?: string) => {
    const configs = category ? statusConfigs : (cat ? groupedConfigs[cat] : Object.values(groupedConfigs).flat());
    return Array.isArray(configs) ? configs.find(s => s.displayName === displayName) : undefined;
  };

  return {
    statusConfigs: category ? statusConfigs : groupedConfigs,
    isLoading,
    isError,
    getDefaultStatus,
    getStatusByKey,
    getStatusByDisplayName
  };
}